import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';

import { InboxService, MenuContentItem, TrackingService } from '@frontend/vanilla/core';
import { MenuItemComponent } from '@frontend/vanilla/features/menus';
import { AccountMenuTasksService } from '@frontend/vanilla/shared/account-menu';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    imports: [MenuItemComponent],
    selector: 'vn-inbox-card',
    templateUrl: 'inbox-card.html',
})
export class InboxCardComponent implements OnInit, OnDestroy {
    private inboxService = inject(InboxService);
    private accountMenuTasksService = inject(AccountMenuTasksService);
    private trackingService = inject(TrackingService);

    @Input() item: MenuContentItem;
    inboxMessagesText: string | undefined;
    private unsubscribe = new Subject<void>();

    ngOnInit() {
        this.inboxService.whenReady.pipe(takeUntil(this.unsubscribe)).subscribe(() => {
            this.inboxService.count.pipe(takeUntil(this.unsubscribe)).subscribe((count: number) => {
                this.inboxMessagesText = this.item.resources['Text']!.replace('_COUNT_', (count || 0).toString());
            });
        });

        this.trackingService.triggerEvent('contentView', {
            'component.CategoryEvent': 'my profile',
            'component.LabelEvent': 'my hub',
            'component.ActionEvent': 'load',
            'component.PositionEvent': `pending tasks ${this.accountMenuTasksService.totalCount} - urgent tasks ${this.accountMenuTasksService.totalUrgentCount}`,
            'component.LocationEvent': 'my hub page',
            'component.EventDetails': 'my inbox section',
            'component.URLClicked': 'not applicable',
        });
    }

    ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}
